import { Task, Timestamp, UpcomingPeriod, WeekDays } from '@griply/types';
import { getUpcomingPeriods } from '@griply/utils';
import { useMemo } from 'react';

export type UseUpcomingPeriodsOptions = {
  today: Timestamp;
  weekStartsOn: WeekDays;
};

export const useUpcomingPeriods = (
  task: Task,
  { today, weekStartsOn }: UseUpcomingPeriodsOptions,
): UpcomingPeriod[] =>
  useMemo(
    () => getUpcomingPeriods(task, { today, weekStartsOn }),
    [task, today, weekStartsOn],
  );
